import styled from 'styled-components'

import { FONT_SIZE, NATIVE_BASE_COLORS, COLOR } from '../../themes'
import { colorThemeSelector } from '../../helpers'

export const StyleRepeatModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};

  .repeat-header-modal {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
  }
`

export const StyleRepeatModalContent = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};
  
  .active-content {
    pointer-events: auto;
    opacity: 1;
  }

  .inactive-content {
    pointer-events: none;
    opacity: 0.20;
  }

  .error-message {
    color: ${NATIVE_BASE_COLORS.ERROR[500]};
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    margin-top: 5px;
  }

  .box-error {
    background-color: ${COLOR.OCCURRENCES_ERROR};
    border: 1px solid ${NATIVE_BASE_COLORS.ERROR[500]};
  }
`

export const StyleRepeatModalFooter = styled.div`
  padding: 20px;

  .submit-button {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 10px 12px;
    justify-content: center;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
    outline: none;
    border: 0px;
    border-radius: 4px;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.SM};
    cursor: pointer;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
`
